import CreateInvestmentError from './CreateInvestmentError';
class InvestmentLimitAmountExceeded extends CreateInvestmentError {
    constructor(options) {
        super('The limit of amount to invest has been reached', options);
    }
}
export default InvestmentLimitAmountExceeded;
